import React, { Component } from 'react'
import { connect } from 'react-redux';
import {
    deslogar,
    listaDocumentos
} from '../actions/'

class Header extends Component{
    constructor(){
        super()

        this.state ={
            search: ''
        }
        this.formSubmit = this.formSubmit.bind(this)
        this.inputChange = this.inputChange.bind(this)
    }

    filtro(por,search){
        let filtro = (por == undefined && search == undefined) ? null : {por,search}
        this.props.listaDocumentos(filtro)
    }

    formSubmit(e){
        e.preventDefault()
        this.filtro('nome',this.state.search)
    }

    inputChange(e){
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render(){
        return( 
            <nav className="navbar fixed-top navbar-expand-lg" style={{ backgroundColor: '#00406d'}}>
                <a  className="navbar-brand" href="/documentos" style={{ color: 'white'}}>
                    {/* <img style={customStyles.img} src="/assets/imagem/logo.png" className="d-inline-block align-top"  /> */}
                    Portal Assinatura
                </a>

                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent" >
                    <ul className="navbar-nav mr-auto">

                        {/* <li className="nav-item dropdown">
                            <a style={{ color:'white'}} className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Filtrar
                            </a>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <a className="dropdown-item" href="#" onClick={ ()=> this.filtro()}>Documentos</a>
                                <a className="dropdown-item" href="#" onClick={ ()=> this.filtro('status', 'em processo')}>Em processo</a>
                                <a className="dropdown-item" href="#" onClick={ ()=> this.filtro('status', 'finalizado')}>Concluidos</a>
                                <a className="dropdown-item" href="#" onClick={ ()=> this.filtro('status', 'cancelado')}>Lixeira</a>
                            </div>
                        </li> */}

                    </ul>

                    {/* <form className="form-inline my-2 my-lg-0" onSubmit={this.formSubmit}>
                        <input name='search' className="form-control mr-sm-2 rounded" type="search" placeholder="Pesquisar"
                            aria-label="Pesquisar" onChange={this.inputChange} />
                        <button className="btn btn-outline-light my-2 my-sm-0" type="submit">Pesquisar</button>
                    </form> */}
                    <span style={{ color: 'white', fontSize: 16}}>Finsol Microfinanças</span>

                    <ul className="navbar-nav px-3">
                        <li className="nav-item text-nowrap">
                            <button className="btn btn-outline-light my-2 my-sm-0" onClick={() => this.props.deslogar()} style={{cursor:'pointer'}}>Sair</button>
                        </li>
                    </ul> 
                </div>


 

          </nav>
        )
    }
}

const mapStateToProps = ({ auth }) => {
    return {
        auth
    }
}

export default connect(mapStateToProps, {
    deslogar,
    listaDocumentos
})(Header);

const customStyles = {
    img: {
        width: 30,
        heigth: 30,
        marginRight: 10
    },
    navbarBrand:{
        paddingTop: '.75rem',
        paddingBottom: '.75rem',
        fontSize: '1rem',
        // backgroundColor: 'rgba(0, 0, 0, .25)',
        // boxShadow: 'inset -1px 0 0 rgba(0, 0, 0, .25)',
    },
    text:{
        fontSize: '1.25rem'
    }
}